module.exports = __webpack_public_path__ + "static/img/avatar_f.8f6ab963.png";